import { AssignmentRecordPartnerProcessStateEnum } from '@coin/shared/core/util-models-v2';

/** If record process state >= frozen, then all operations except "Download TAF Letter" are disabled */
export function isProcessStateAboveOrEqualToFrozen(recordProcessState: AssignmentRecordPartnerProcessStateEnum) {
  return [
    AssignmentRecordPartnerProcessStateEnum.Frozen,
    AssignmentRecordPartnerProcessStateEnum.AchievementLetterCreated,
    AssignmentRecordPartnerProcessStateEnum.AchievementLetterPublished
  ].includes(recordProcessState);
}
